module.exports = __webpack_public_path__ + "static/media/Roboto-500.1d659482.woff";